export default __webpack_public_path__ + "static/media/ThePiano_00.35548eef.png";